export const IPushNotificationsServiceType = Symbol('IPushNotificationsService');
